import { API, apiRequest } from "../api";
import {
    CreateExamByBookReq,
    CreateExamByBookRsp,
    CreateSixTwoHighsReq,
    CreateSixTwoHighsRsp,
    GetBookReq,
    GetBookRsp,
    GetShelfBookReq,
    GetShelfBookRsp,
    GetShelfBooksReq,
    GetShelfBooksRsp,
    PrepareCreateExamReq,
    PrepareCreateExamRsp,
    RestartExamByBookReq,
    RestartExamByBookRsp,
    TryCreateSixTwoHighsReq,
    TryCreateSixTwoHighsRsp,
} from "./book";

const apiGetBook: API<GetBookReq, GetBookRsp> = {
    url: "/api/book/get",
};

export function methodGetBook(dispatch: any, req: GetBookReq) {
    return apiRequest({ api: apiGetBook, req, dispatch });
}

export interface GetShelfBooksRspInput {
    userID?: string;
    kind: number;
    kind2?: number;
    kind3?: number;
    kind4s?: number[];
    kindExts?: number[];
    noLogin?: boolean;
}

const apiGetShelfBooks: API<GetShelfBooksReq, GetShelfBooksRsp> = {
    url: "/api/book/get_shelf",
};

export function methodGetShelfBooks(dispatch: any, req: GetShelfBooksRspInput) {
    const req2 = {
        kind: req.kind,
        kind2: req.kind2 !== undefined ? req.kind2 : -1,
        kind3: req.kind3 !== undefined ? req.kind3 : -1,
        kind4s: req.kind4s !== undefined ? req.kind4s : [],
        kind_exts: req.kindExts !== undefined ? req.kindExts : ([] as number[]),
        no_login: req.noLogin ? true : false,
        user_id: req.userID !== undefined ? req.userID : "",
    } as GetShelfBooksReq;
    return apiRequest({ api: apiGetShelfBooks, req: req2, dispatch });
}

const apiGetShelfBook: API<GetShelfBookReq, GetShelfBookRsp> = {
    url: "/api/book/get_shelf_one",
};

interface GetShelfBookReqInput {
    kind: number;
    kind2?: number;
    kind3?: number;
    noLogin?: boolean;
}

export function methodGetShelfBook(dispatch: any, req: GetShelfBookReqInput) {
    const req2 = {
        kind: req.kind,
        kind2: req.kind2 !== null ? req.kind2 : -1,
        kind3: req.kind3 !== null ? req.kind3 : -1,
        no_login: req.noLogin ? true : false,
    } as GetShelfBookReq;
    return apiRequest({ api: apiGetShelfBook, req: req2, dispatch });
}

const apiCreateExamByBook: API<CreateExamByBookReq, CreateExamByBookRsp> = {
    url: "/api/book/create_exam",
};

export function methodCreateExamByBook(dispatch: any, req: CreateExamByBookReq) {
    return apiRequest({ api: apiCreateExamByBook, req, dispatch, backdrop: true });
}

const apiRestartExamByBook: API<RestartExamByBookReq, RestartExamByBookRsp> = {
    url: "/api/book/restart_exam",
};

export function methodRestartExamByBook(dispatch: any, req: RestartExamByBookReq) {
    return apiRequest({ api: apiRestartExamByBook, req, dispatch, backdrop: true });
}

const apiPrepareCreateExam: API<PrepareCreateExamReq, PrepareCreateExamRsp> = {
    url: "/api/book/prepare_create_exam",
};

export function methodPrepareCreateExam(dispatch: any, req: PrepareCreateExamReq) {
    return apiRequest({ api: apiPrepareCreateExam, req, dispatch, dealErr: true });
}

const apiCreateSixTwoHighs: API<CreateSixTwoHighsReq, CreateSixTwoHighsRsp> = {
    url: "/api/template/create_six_two_highs",
};

export function methodCreateSixTwoHighs(dispatch: any, req: CreateSixTwoHighsReq) {
    return apiRequest({ api: apiCreateSixTwoHighs, req, dispatch, backdrop: true });
}

const apiTryCreateSixTwoHighs: API<TryCreateSixTwoHighsReq, TryCreateSixTwoHighsRsp> = {
    url: "/api/template/try_create_six_two_highs",
};

export function methodTryCreateSixTwoHighs(dispatch: any, req: TryCreateSixTwoHighsReq) {
    return apiRequest({ api: apiTryCreateSixTwoHighs, req, dispatch, backdrop: true });
}
